import React, { useEffect } from 'react';
import styles from './detailsModal.scss';
import classNames from 'classnames';
import { DetailsModalContent } from './detailsModalContent/detailsModalContent';
import Cross from '../icons/cross';
import ArrowSmallIcon from '../icons/arrowSmallIcon';
import { IProductInfoStore } from '../../types';
import { inject, observer } from 'mobx-react';
import TabNavigationHelper from '../../helpers/tabNavigationHelper';
import { decodeHTML } from '../../helpers/html-helper';

const DetailsModal = inject('productInfoStore')(
    observer(({ productInfoStore }: IProductInfoStore) => {
        const tabNavigation: TabNavigationHelper = TabNavigationHelper.instance;
        const detailsModalRef = React.useRef<HTMLDivElement>(null);
        useEffect(() => {
            if (productInfoStore.isDetailsModalOpen) {
                tabNavigation.setModalAtt(detailsModalRef.current);
                if (detailsModalRef.current) {
                    const firstFocusable = detailsModalRef.current.querySelectorAll('[focusable]')[0];
                    window.shell.tabNav.focus(firstFocusable);
                }
            }
        }, [productInfoStore.isDetailsModalOpen]);

        if (!productInfoStore.isDetailsModalOpen) {
            return <></>;
        }

        function redirectToDetailPage() {
            const dpURL = new URL(productInfoStore.openedArticleSetItem?.linkToDetailsPage || '');
            dpURL.searchParams.set('itemorigin', productInfoStore.itemOrigin);
            window.open(dpURL.href, '_blank');
        }

        const selectedBrickItem = productInfoStore.selectedBrickItem();

        let testId = 'details_modal_root'
        let categoryLayerIndex = 0;
        switch (productInfoStore.itemOrigin) {
            case 'FlexSets-0-picture': {
                testId = 'flexset-picture-layer_0-modal';
                break;
            }
            case 'FlexSets-0-list': {
                testId = 'flexset-list-layer_0-modal';
                break;
            }
            case 'FlexSets-1': {
                testId = 'flexset-button-layer_1-modal';
                categoryLayerIndex = 1
                break;
            }
            case 'FlexSets-2': {
                testId = 'flexset-button-layer_2-modal';
                categoryLayerIndex = 1;
                break;
            }
        }

        const layerOneIndex = productInfoStore.openedArticleSetItem?.
            selectedBrickItemNo ? productInfoStore.openedArticleSetItem?.
            selectedBrickItemNo - 1 : 0;

        return (
            <div className={styles.details_modal}>
                <div ref={detailsModalRef} className={styles.details_modal_container} data-testid='details_modal_container'>
                    <div className={styles.details_modal_content} data-testid='details_modal_content'>
                        <div className={styles.details_modal_header} data-testid='details_modal_header'>
                            <div className={styles.details_modal_text_area}>
                                {selectedBrickItem.isFreeInSet &&
                                    <div className={styles.free_in_set}>
                                        {decodeHTML(selectedBrickItem.gratisMlt)}
                                    </div>}
                                <span className={styles.details_modal_title} data-testid='details_modal_title'>
                                    {productInfoStore.articleSetItemDetail?.orderModule.articleInfo.title}
                                </span>
                                <div className={styles.color_size_info} data-testid='details_modal_color_size_info'>
                                    {productInfoStore.getVariantLabel(productInfoStore.openedArticleSetItem)}
                                </div>
                            </div>
                            <div className={styles.close_button} id='article_sets_details_modal_close_button'
                                ref={(el) => tabNavigation.setFocusAtt(el)}
                                onClick={() => productInfoStore.handleDetailsButtonClick(false)}>
                                <Cross />
                            </div>
                        </div>
                        {productInfoStore.articleSetItemDetail &&
                            <div className={styles.details_modal_middle} data-testid='details_modal_middle'>
                                <DetailsModalContent data={productInfoStore.articleSetItemDetail} />
                            </div>
                        }
                        <div className={styles.transition_on_scroll_down} />
                        <div className={styles.details_modal_footer} data-testid='details_modal_footer'>
                            <div className={classNames(styles.footer_button, styles.white)}
                                id='to_details_page_button'
                                data-testId={testId}
                                data-flexset-id={productInfoStore.mainStore.dataStore.orderModule.flexSetInfo.fsCode}
                                data-flexset-name={productInfoStore.mainStore.dataStore.orderModule.flexSetInfo.displayName}
                                data-flexset-module-layer_0-index={productInfoStore.getOMBrickPosition()}
                                 data-flexset-module-layer_0-category={categoryLayerIndex === 0 ?
                                     productInfoStore.articleSetItemDetail?.breadcrumb.category.navigationKeyPath : null}
                                data-flexset-module-layer_1-category={categoryLayerIndex > 0 ?
                                    productInfoStore.articleSetItemDetail?.breadcrumb.category.navigationKeyPath : null}
                                data-flexset-module-layer_1-index={layerOneIndex}
                                data-flexset-item-name={productInfoStore.openedArticleSetItem?.salesDesignation}
                                data-flexset-item-sku={productInfoStore.mainStore.getSalesArticleNo(
                                     productInfoStore.openedArticleSetItem?.salesArticleVariantKey)}
                                // eslint-disable-next-line max-len
                                onClick={() => redirectToDetailPage()}
                                ref={(el) => tabNavigation.setFocusAtt(el)}>
                                <div className={styles.to_details_page}>
                                    {productInfoStore.mainStore.localization?.generalL10n.toTheDetailsPage}
                                </div>
                                <ArrowSmallIcon />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }));

export default DetailsModal;
